// ███ ONE DEFINITION OF THE AWARDS ROSTEREM HAS INGESTED ███
//
// Phase 6c T2 (2026-10-24). Moved here from `src/utils/awardCode.js`, which now
// re-exports it, because `shared/xero-rule-rows`' label ladder needs an award's
// venue-facing name and **`shared/` cannot import from `src/`** — a measured
// constraint recorded in that module's own header and pinned by a control. The
// same move was made for the rows enumerator itself, whose header records it.
//
// The alternative — passing the display names in from each caller — would put a
// venue-facing vocabulary in two call sites, and a second list inside `shared/`
// would be a hand-maintained list checked by nothing. One definition, re-exported.
//
// ⚠ THE KIND SEGMENT IS LOWERCASE AND `code` IS UPPERCASE, AND THAT IS THE WHOLE
// HAZARD IN THIS FILE. A rule kind's first segment is `ma000009`; the entry's
// `code` is `MA000009`. A lookup comparing them directly returns nothing for
// every real input — and "nothing" is indistinguishable from "an award Rosterem
// does not know", which the ladder is REQUIRED to render as no suffix at all. So
// the miss would be silent, in the direction of printing a correct-looking label
// that has quietly dropped the one word a venue needed. `awardShortName`
// normalises case, and a test drives it from the lowercase kind form
// specifically, because the uppercase form is the one that would pass either way.

const SUPPORTED_AWARDS = Object.freeze([
  Object.freeze({
    code: 'MA000009',
    name: 'Hospitality Industry (General) Award',
    shortName: 'Hospitality Award',
    description: 'Hotels, pubs, clubs, and accommodation venues — most licensed premises, bars, and function venues.',
  }),
  Object.freeze({
    code: 'MA000119',
    name: 'Restaurant Industry Award',
    shortName: 'Restaurant Award',
    description: 'Standalone restaurants and cafes that are not attached to a hotel, club, pub, or accommodation venue.',
  }),
]);

// The venue's short words for an award code, or `null` for one this product has
// not ingested. NEVER the code itself as a fallback: `· MA000119` in a label is
// a leak of an internal identifier, which is the same defect as `· permanent`
// one vocabulary along.
function awardShortName(code) {
  if (typeof code !== 'string' || code.trim() === '') return null;
  const want = code.trim().toUpperCase();
  const hit = SUPPORTED_AWARDS.find((a) => a.code.toUpperCase() === want);
  return hit ? hit.shortName : null;
}

module.exports = { SUPPORTED_AWARDS, awardShortName };
